
import React from "react";
import fields from "../../json/ShiftFields.json";
import FormInput from "Common/Custom/FormInput";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AddShiftForm = ({ values, errors, handleChange, handleSubmit, loading }) => {
  const { formFields } = fields;
  return (
    <PageBody
      headerchildren={
        <HeadingOne>Add Shift</HeadingOne>
      }
      onSubmit={handleSubmit}>
      {formFields.map((field) =>
        field.type === "time" ? (
          <FormDatePicker
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
            mode="time"
          />
        ) : (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        )
      )}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddShiftForm;
